var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_1626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9136 9.56188C12.8931 7.28438 14.7737 6.19092 14.8568 6.14024C13.8 4.59279 12.1522 4.37712 11.5678 4.35124C10.1648 4.20997 8.82981 5.17834 8.12025 5.17834C7.41069 5.17834 6.31076 4.37496 5.15044 4.39761C3.61917 4.4181 2.21299 5.28725 1.4247 6.65138C-0.162644 9.40551 1.01708 13.4882 2.56669 15.7215C3.32154 16.8149 4.22197 18.0432 5.40493 17.999C6.54692 17.9548 6.97826 17.2625 8.35641 17.2625C9.73455 17.2625 10.1217 17.999 11.3284 17.9806C12.5545 17.9548 13.332 16.8613 14.0803 15.7678C14.9473 14.4986 15.3075 13.2704 15.328 13.2057C15.3011 13.196 12.9362 12.288 12.9125 9.56188H12.9136Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6456 2.87275C11.2754 2.11251 11.6992 1.05356 11.5827 0C10.678 0.0345075 9.58126 0.604961 8.93316 1.36197C8.34977 2.0381 7.83755 3.11862 7.97666 4.14953C8.98493 4.2261 10.0191 3.63515 10.6456 2.87275Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_1626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6582,
    height: 18,
    fill: "white",
    transform: "translate(0.670898)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.532edf1f59284f13b5a5c0eb7890f4a9.svg";
export { ForwardRef as ReactComponent };